import React from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux'
import * as actions from "./contextMenuActions";
import AbstractReactComponent from './../AbstractReactComponent';
import classNames from 'classnames';

import "./ContextMenuContainer.scss";

const ContextMenuContainer = class extends AbstractReactComponent {
    constructor(props) {
        super(props);

        this.state = {
            left: 0,
            top: 0,
        }
    }

    static PropTypes = {
        // customHide: React.PropTypes.bool,
    };

    static defaultProps = {
        // customHide: false
    };

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickDown);
        document.addEventListener("keydown", this.handleKeyDown);
        document.addEventListener("mouseup", this.handleClickUp);
        document.addEventListener("touchstart", this.handleClickDown);
        document.addEventListener("touchend", this.handleClickUp);
        window.addEventListener("resize", this.hideMenu);
        document.addEventListener("scroll", this.hideMenu);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickDown);
        document.removeEventListener("keydown", this.handleKeyDown);
        document.removeEventListener("mouseup", this.handleClickUp);
        document.removeEventListener("touchstart", this.handleClickDown);
        document.removeEventListener("touchend", this.handleClickUp);
        window.removeEventListener("resize", this.hideMenu);
        document.removeEventListener("scroll", this.hideMenu);
    }

    handleKeyDown = (e) => {
        const {visible} = this.props.contextMenu;
        if (visible && e.keyCode == 27) {
            e.preventDefault();
            e.stopPropagation();
            this.hideMenu();
        }
    };

    hideMenu = () => {
        this.props.dispatch(actions.hide());
    };

    handleClickUp = (e) => {
    };

    handleClickDown = (e) => {
        const {customHide, visible} = this.props.contextMenu;

        if (!visible) {
            return;
        }

        let source = e.target;
        let found = false;
        const node = ReactDOM.findDOMNode(this.refs.contextMenu);

        while (source) {
            // console.log(source, contextMenuDomNode, source === contextMenuDomNode, source == contextMenuDomNode)
            found = (source === node);
            if (found) {
                if (!customHide) {
                    setTimeout(() => {
                        this.hideMenu();
                    }, 80);
                }
                return;
            }

            source = source.parentNode;
        }

        this.hideMenu();
    };

    componentDidUpdate(prevProps, prevState) {
        // Nastavení chceme jen při změně props, nikoli state!
        if (prevProps !== this.props) {
            this.setPosition();
        }
    }

    setPosition = () => {
        const {visible, position} = this.props.contextMenu;

        if (visible) {
            const node = ReactDOM.findDOMNode(this.refs.contextMenu);
            const rect = node.getBoundingClientRect();
            const ww = window.innerWidth;
            const wh = window.innerHeight;
            const menuHeight = node.offsetHeight;
            const menuWidth = node.offsetWidth;

            let x = position.x;
            let y = position.y;

            // Spočtení umístění menu
            let top;
            let left;
            if (y + menuHeight > wh) {    // nevejde se dolu, dáme ho nahoru
                top = y - menuHeight;
            } else {    // dáme ho dolu
                top = y;
            }
            if (x + menuWidth > ww) {   // nevejde se vpravo, dáme ho vlevo
                left = x - menuWidth;
            } else {    // dáme ho vpravo
                left = x;
            }

            this.setState({
                left,
                top
            });
        }
    };

    render() {
        const {visible, component, componentProps, position} = this.props.contextMenu;
        const {customHide, className, dispatch, contextMenu, ...other} = this.props;
        const {left, top} = this.state;

        if (!visible) {
            return null;
        }

        const wrapperClassNames = classNames(
            className,
            "context-menu-container",
            {
                "open": visible
            }
        );


        const comp = React.createElement(component, componentProps);
        const style = {
            left,
            top
        };

        return <div
            style={style}
            ref="contextMenu"
            className={wrapperClassNames}
            {...other}
        >
            {comp}
        </div>
    }
};

function mapStateToProps(state) {
    return {
        contextMenu: state.contextMenu
    }
}

export default connect(mapStateToProps)(ContextMenuContainer);
